import React from 'react';
import Seo from '../components/Seo';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Clock } from 'lucide-react';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import { insights } from '../data/insights';

const fmt = (d) => new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

const Insights = () => {
  const [featured, ...rest] = insights;

  return (
    <div>
      <Seo
        title="Insights & Guides for Rice Importers"
        description="Expert guides on importing rice from Pakistan: basmati varieties, rice grades, buyer checklists and market insights from Kassam Trading Company."
        path="/insights"
      />
      <PageHero
        title="Insights & Export Guides"
        subtitle="Practical guides for importers sourcing rice, salt and grains from Pakistan — varieties, grades, specifications and market know-how."
        crumb="Insights"
      />

      <section className="max-w-7xl mx-auto px-6 py-16" data-testid="insights-list">
        {/* Featured */}
        <Reveal>
          <Link to={`/insights/${featured.slug}`} data-testid="insight-featured" className="group grid lg:grid-cols-2 gap-8 items-center bg-ktc-ivoryLight rounded-2xl border border-ktc-cream overflow-hidden card-lift">
            <div className="img-zoom h-72 lg:h-full">
              <img src={featured.image} alt={featured.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-8 lg:pr-10">
              <div className="flex items-center gap-3 text-xs">
                <span className="bg-ktc-gold text-ktc-greenDark font-semibold px-3 py-1 rounded-full">{featured.category}</span>
                <span className="flex items-center gap-1.5 text-ktc-charcoal/55"><Calendar size={13} /> {fmt(featured.date)}</span>
                <span className="flex items-center gap-1.5 text-ktc-charcoal/55"><Clock size={13} /> {featured.readTime}</span>
              </div>
              <h2 className="font-serif text-3xl font-semibold text-ktc-green mt-4 leading-snug">{featured.title}</h2>
              <p className="text-ktc-charcoal/70 mt-3 leading-relaxed">{featured.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-ktc-gold font-semibold text-sm mt-5 group-hover:gap-2.5 transition-all">Read guide <ArrowRight size={15} /></span>
            </div>
          </Link>
        </Reveal>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {rest.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 70}>
              <Link to={`/insights/${a.slug}`} data-testid={`insight-card-${a.slug}`} className="group block bg-ktc-ivoryLight rounded-xl border border-ktc-cream overflow-hidden card-lift h-full">
                <div className="img-zoom h-44"><img src={a.image} alt={a.title} className="w-full h-full object-cover" /></div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs">
                    <span className="bg-ktc-cream text-ktc-green font-semibold px-2.5 py-1 rounded-full">{a.category}</span>
                    <span className="flex items-center gap-1.5 text-ktc-charcoal/50"><Clock size={12} /> {a.readTime}</span>
                  </div>
                  <h3 className="font-serif text-xl font-semibold text-ktc-green mt-3 leading-snug">{a.title}</h3>
                  <p className="text-sm text-ktc-charcoal/65 mt-2 line-clamp-3">{a.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Insights;
